var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'hx-util';
export function OverLayBanner(_a) {
    var content = _a.content, className = _a.className;
    return (_jsx("div", __assign({ className: cn('absolute bottom-[5%] left-0 w-full inline-flex items-center justify-center', className) }, { children: content })));
}
